<div class="mat-form-field-relative-wrapper">
  @if (label || hasUpdatePermission) {
    <div class="input-assign-role-header">
      <div class="input-assign-role-header-name">{{ label }}</div>
      <div class="flex-space"></div>
      @if (hasUpdatePermission) {
        <nimbus-input-parameters-overlay
          customClass="with-paddings"
          [optionsToAdd]="optionsToAdd"
          [selectableBodyTemplateRef]="itemSelectableBody"
          [isLoading]="false"
          [filtering]="false"
          [isDisabled]="isDisabled"
          (itemAdd)="insertParameter($event)"
          (closePanel)="onClose()"
          (searchPhrase)="onSearch($event)"
        >
        </nimbus-input-parameters-overlay>
      }
    </div>
  }

  <div class="service-profile-list">
    <nimbus-grid
      class="flex-grow"
      [data]="entities$ | async"
      [loading]="loading$ | async"
      [pageSize]="pageSize$ | async"
      [pageable]="{ responsive: false }"
      [skip]="skip"
      [sort]="sort$ | async"
      [sortable]="{ allowUnsort: false, mode: 'single' }"
      (pagingChange)="pagingChange($event)"
      (sortingChange)="sortingChange($event)"
    >
      @if (isBulk) {
        <nimbus-grid-column width="20" field="bulkIdentical">
          <ng-template let-dataItem="dataItem">
            <div
              class="bulk-identical"
              [nimbusBulkValue]="getBulkItem(dataItem.id)"
              [identical]="getBulkItem(dataItem.id)?.identical"
              [isBulk]="isBulk"
            ></div>
          </ng-template>
        </nimbus-grid-column>
      }

      <nimbus-grid-column class="text-limit" field="name" [title]="TranslationKeys.GeneralName | translate">
        <ng-template let-dataItem="dataItem">
          <div class="profile-name-cell">
            @if (isNpdItem(dataItem.id)) {
              <span class="bulk-disabled-warning tooltip-container">
                <i [nimbusIcon]="ICONS.WARNING_LIGHT"></i>
                <nimbus-tooltip
                  [text]="
                    (isBulk ? TranslationKeys.AdminUserListProfilesCannotBeApplied : TranslationKeys.GeneralNpdItemWarning) | translate
                  "
                  [position]="'left'"
                ></nimbus-tooltip>
              </span>
            }
            <span class="text-no-wrap tooltip-container" [class.bulk-disabled]="isBulk && !getBulkItem(dataItem.id)?.identicalItems">
              {{ dataItem.name }}
            </span>
          </div>
        </ng-template>
      </nimbus-grid-column>

      <nimbus-grid-column field="isDuty" width="70" [title]="TranslationKeys.GeneralIsDuty | translate">
        <ng-template let-dataItem="dataItem">
          <div
            class="readonly-switch-box"
            [class.enabled]="dataItem.isDuty"
            [class.bulk-disabled]="isBulk && !getBulkItem(dataItem.id)?.identicalItems"
          ></div>
        </ng-template>
      </nimbus-grid-column>

      <nimbus-grid-column field="default" width="70" [title]="TranslationKeys.GeneralDefault | translate">
        <ng-template let-dataItem="dataItem" let-rowIndex="rowIndex">
          <span class="tooltip-container">
            <mat-radio-button
              class="tooltip-container"
              [nimbusBulkValue]="getBulkValue(dataItem.id, 'default')"
              [identical]="getBulkValue(dataItem.id, 'default')?.identical"
              [isBulk]="isBulk"
              [checked]="dataItem.default"
              [name]="isBulk ? 'default' + rowIndex : 'default'"
              [disabled]="isBulk ? !getBulkItem(dataItem.id)?.identicalItems : !hasUpdatePermission"
              (change)="setDefault(dataItem.id)"
              (click)="onClickSetDefault(dataItem)"
            ></mat-radio-button>

            @if (isBulk && !getBulkItem(dataItem.id)?.identicalItems && !isBulkReadonlyLocal(dataItem.id)) {
              <nimbus-tooltip [text]="TranslationKeys.AdminUserListProfilesApplyNeeds | translate"></nimbus-tooltip>
            }
          </span>
        </ng-template>
      </nimbus-grid-column>

      <nimbus-grid-column field="active" width="70" [title]="TranslationKeys.GeneralActive | translate">
        <ng-template let-dataItem="dataItem" let-rowIndex="rowIndex">
          <span class="tooltip-container">
            <mat-radio-button
              class="tooltip-container"
              [nimbusBulkValue]="getBulkValue(dataItem.id, 'active')"
              [identical]="getBulkValue(dataItem.id, 'active')?.identical"
              [isBulk]="isBulk"
              [checked]="dataItem.active"
              [name]="isBulk ? 'active' + rowIndex : 'active'"
              [disabled]="isBulk ? !getBulkItem(dataItem.id)?.identicalItems : !hasUpdatePermission"
              (change)="setActive(dataItem.id)"
              (click)="onClickSetActive(dataItem)"
            ></mat-radio-button>
            @if (isBulk && !getBulkItem(dataItem.id)?.identicalItems && !isBulkReadonlyLocal(dataItem.id)) {
              <nimbus-tooltip [text]="TranslationKeys.AdminUserListProfilesApplyNeeds | translate"></nimbus-tooltip>
            }
          </span>
        </ng-template>
      </nimbus-grid-column>

      <nimbus-grid-column field="id" textAlignment="right" [sortable]="false" class="actions-column" [width]="isBulk ? 50 : 25">
        <ng-template let-dataItem="dataItem" let-rowIndex="rowIndex">
          <div class="grid-control-icons flex-container flex-align-center-right">
            @if (isBulk) {
              <button
                nimbusPrimaryIconButton
                [disabled]="getBulkItem(dataItem.id)?.identicalItems || isBulkReadonlyLocal(dataItem.id)"
                (click)="onApplyItem(dataItem)"
              >
                <i [nimbusIcon]="ICONS.ADD"></i>
                <nimbus-tooltip position="left" [text]="getApplyTooltip(dataItem.id) | translate"></nimbus-tooltip>
              </button>
            }
            @if (!dataItem?.readonly && hasUpdatePermission) {
              <button nimbusNegativeButton nimbusPrimaryIconButton [disabled]="dataItem.default" (click)="onRemoveItemClick(dataItem)">
                <i [nimbusIcon]="ICONS.TRASH_LIGHT"></i>
                <nimbus-tooltip
                  position="left"
                  [text]="
                    (dataItem.default ? TranslationKeys.AdminUserListProfilesCannotBeDeleted : TranslationKeys.GeneralRemove) | translate
                  "
                ></nimbus-tooltip>
              </button>
            }
          </div>
        </ng-template>
      </nimbus-grid-column>
    </nimbus-grid>
  </div>

  <ng-template #itemSelectableBody let-item="item">
    <div class="flex-container url-parameter">
      {{ item.name }}
      <nimbus-tooltip [text]="item.name | translate"></nimbus-tooltip>
    </div>
  </ng-template>
</div>
